import _ from "lodash";
import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import Grid from "src/library/components/Hedron";
import { Select } from "src/library/components/Forms";
import { Icon } from "src/library/components/Icon";
import { Icons } from "src/library/components/Icon/types";
import { IOrderLine } from "src/core/orders/api/orders.api";

import { ICreditRequestReasonCode } from "../api/credit-request.api";

interface CreditReasonSelectProps {
  availableCreditReasons: ICreditRequestReasonCode[];
  orderLine: IOrderLine;
  onAddCreditReason: (creditReasonId: number) => void;
  showApprovalColumn: boolean;
}

/**
 * Select box for choosing a credit reason
 */
export const CreditReasonSelect: React.ReactFCWithChildren<CreditReasonSelectProps> = ({
  availableCreditReasons, orderLine, onAddCreditReason, showApprovalColumn
}) => {
  const [ showError, setShowError ] = useState(false);

  /** On mount, if there is only one credit reason then use that for autifilling the reason code * */
  React.useEffect(() => {
    if (availableCreditReasons.length === 1) {
      onAddCreditReason(availableCreditReasons[ 0 ].id);
      setShowError(false);
    }
  }, [ availableCreditReasons, onAddCreditReason ]);

  if (!availableCreditReasons.length) {
    return null;
  }

  return (
    <ReasonSelectWrapper
      direction="horizontzal"
      className="row-right"
    >
      <div className="requested-quantity-col credit-col" />

      <div className="reason-col credit-col">
        <Select
          disabled={availableCreditReasons.length === 1}
          className="reason-select-box"
          name={`credit-reason-${orderLine.id}`}
          label="Select reason"
          as="select"
          autoHideLabels
          defaultValue={availableCreditReasons.length === 1 ? availableCreditReasons[ 0 ].id.toString() : ""}
          unselectedOption={{
            text: "Select reason",
            value: ""
          }}
          handleChange={e => {
            onAddCreditReason(parseInt(e.currentTarget.value));
            setShowError(false);
          }}
          options={_.map(availableCreditReasons, cr => ({
            text: cr.name,
            value: cr.id.toString()
          }))}
        />

        {showError && (
          <Text color="error">
            Please select a reason
          </Text>
        )}

        <div className="add-button">
          <Icon
            icon={Icons.ADD}
            size={20}
            $fillColor="lightGrey"
          />
        </div>

      </div>

      {showApprovalColumn &&
        <div className="approved-quantity-col credit-col" />}
    </ReasonSelectWrapper>
  );
};

const ReasonSelectWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    width: 100%!important;

    .reason-col {
      display: flex;
    }

    .reason-select-box {
      width: 170px;
    }

    .add-button {
      display: flex;
      align-items: center;
      width: 25px;
      margin-left: 5px;

      &:hover {
        cursor: pointer;
        border-color: ${theme.colors.midGrey};
      }
    }
  `}
`;
